import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { IModalDeleteData, IUser } from '../../../model/user/IUser';
import { UserService } from '../UserService';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { UPDATED_USER } from '../../../enum/Messages';
import { Contact } from '../../../model/shared/Contact';
import { IAgency } from '../../agency/dto/IAgency';
import { CompanyService } from '../../company/CompanyService';
import { Company } from '../../../model/company/Company';
import { getCorrectEnums, hasAccessRight } from '../../../utils/Functions';
import { ImpersonateEye } from '../../../shared/components/ImpersonateEye';
import { useParams } from 'react-router-dom';
import InfluencerRemoveModal from '../../agency/components/InfluencerRemoveModal';
import AutocompleteInput from '../../../shared/components/AutocompleteInput';
import { ErrorToast } from '../../../utils/toasters';
import { AdminAclEnum } from '../../../enum/AdminAclEnum';

export function UserForm() {
    const { id, isUserList }: any = useParams();
    const navigate = useNavigate();

    const initialContact: Contact = {
        city: '',
        country: '',
        phone: '',
        province: '',
        street: '',
        uidNumber: '',
        zip: '',
    };

    const initialAgency: IAgency = {
        displayName: '',
        firstName: '',
        id: 0,
        lastName: '',
    };

    const [user, setUser] = useState<Partial<IUser>>({
        agency: initialAgency,
        agencyId: 0,
        averageLikeToFollowerRatio: 0,
        birthdate: '',
        brandType: '',
        contact: initialContact,
        displayName: '',
        email: '',
        firstName: '',
        gender: '',
        isEnabled: false,
        lastLogin: '',
        lastLoginIp: '',
        lastName: '',
        referralCode: '',
        roles: [],
        totalEngagements: 0,
        totalFollowers: 0,
        totalReach: 0,
        userType: '',
        username: '',
        hasInfluencerFee: false,
        isIvConnectedClub: false,
        excludeFromMatching: false,
        isPhoneShown: false,
        influencerFeePercentage: 0,
        brandCompany: {
            id: 0,
        },
        hasValueMatch: false,
        valueMatchStart: '',
    });
    const [selectedCompany, setSelectedCompany] = useState('');
    const [companyList, setCompanyList] = useState<Company[]>([]);
    const [filterState, setFilterState] = useState({
        page: 1,
        perPage: 10000,
        title: '',
    });
    const [agencies, setAgencies] = useState<IUser[]>([]);
    const [agenciesParams, setAgenciesParams] = useState('');
    const { userType, roles } = useSelector((state: any) => state.enums);
    const isUserBrand = user?.userType === 'brand_master' || user?.userType === 'brand';
    const [modalDeleteData, setModalDeleteData] = useState<IModalDeleteData>({
        showModal: false,
        userId: 0,
        userName: '',
    });
    const [change, setChange] = useState(false);

    useEffect(() => {
        UserService.getUser(id)
            .then(data => {
                setUser(data);
                setAgenciesParams(data?.agencyCompany?.displayName ?? '');
                setSelectedCompany(data?.brandCompany?.displayName ?? '');
            })
            .catch(err => ErrorToast(err));
    }, [change]);

    useEffect(() => {
        CompanyService.getCompanies(filterState)
            .then(response => {
                setCompanyList(response?.data);
            })
            .catch(err => ErrorToast(err));
    }, [filterState]);

    useEffect(() => {
        UserService.getAgencies({ displayName: agenciesParams, perPage: 10000 })
            .then(data => {
                setAgencies(data.data);
            })
            .catch(err => ErrorToast(err));
    }, [agenciesParams]);

    function editUser() {
        UserService.editUser(id, user)
            .then(data => {
                setUser(data);
                toast(UPDATED_USER);
                navigate(-1);
            })
            .catch(err => ErrorToast(err));
    }

    // function removeUserFromAgency() {
    //     UserService.editUser(id, user)
    //         .then(data => {
    //             setUser(data);
    //             toast(UPDATED_USER);
    //             navigate(-1);
    //         })
    //         .catch(err => ErrorToast(err));
    // }

    function handleChange(evt: any, isNumber = false) {
        const value = isNumber ? +evt.target.value : evt.target.value;
        setUser({
            ...user,
            [evt.target.name]: value,
        });
    }

    function handleCheckbox(evt: React.ChangeEvent<HTMLInputElement>) {
        const { name, checked } = evt.target;

        setUser(prev => {
            if (!prev) return prev;

            if (name === 'hasInfluencerFee' && !checked) {
                return {
                    ...prev,
                    hasInfluencerFee: false,
                    isIvConnectedClub: false,
                };
            }

            return {
                ...prev,
                [name]: checked,
            };
        });
    }

    function handleRole(e: any) {
        const options = e.target.options;
        const value: string[] = [];
        for (let i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                value.push(options[i].value);
            }
        }
        setUser(prev => ({
            ...prev,
            roles: value,
        }));
    }

    const changeFilterHandler = (value: string) => {
        setSelectedCompany(value);
        setFilterState(prev => ({ ...prev, displayName: value }));
    };

    const changeAutoCompleteHandler = (valueToUpdate: Company, field: string) => {
        if (field === 'brandCompany') {
            setSelectedCompany(valueToUpdate?.displayName);
        } else {
            setAgenciesParams(valueToUpdate?.displayName);
            // setUser({...user, agency: {id: valueToUpdate?.id}, agencyCompany: {displayName: valueToUpdate?.displayName}})
        }

        setUser(prev => ({ ...prev, [field]: field === 'agency' ? valueToUpdate.id : valueToUpdate }));
    };
    return (
        <>
            <InfluencerRemoveModal {...modalDeleteData} setModalDeleteData={setModalDeleteData} setChange={setChange} />

            <Row className="align-items-center mb-3">
                <Col className="col-auto">
                    <h3 className="m-0">
                        {user?.displayName
                            ? `ID: ${user.id} Name: ${user.displayName}`
                            : `ID: ${user.id} Name: ${user.firstName} ${user.lastName}`}
                    </h3>
                </Col>
                <Col className="col-auto">
                    <ImpersonateEye id={id} isEnabled={user.isEnabled} classes="btn-primary btn-icon" />
                </Col>
            </Row>
            <Card className="mb-5">
                <Form as={Card.Body}>
                    {(Boolean(isUserList) || ['brand', 'partner'].includes(user?.userType ?? '')) && (
                        <Form.Group
                            as={Col}
                            controlId="formGridState"
                            className="autocomplete-input zindex-5 position-relative d-flex flex-column mb-4"
                        >
                            <Form.Label>Agency</Form.Label>
                            <AutocompleteInput
                                items={agencies}
                                value={agenciesParams ?? ''}
                                renderItems={['displayName']}
                                // renderItem={(item) =>
                                //     <div className='autocomplete-item' key={item.id}>
                                //         {item.displayName ?? '-'}
                                //     </div>
                                // }
                                setFilter={(value: string) => setAgenciesParams(value)}
                                onSelect={agency => changeAutoCompleteHandler(agency, 'agency')}
                            />
                        </Form.Group>
                    )}
                    {agenciesParams && (
                        <Button
                            className="my-4"
                            onClick={() =>
                                setModalDeleteData({
                                    ...modalDeleteData,
                                    showModal: true,
                                    userId: Number(user.id),
                                    userName: user?.displayName,
                                })
                            }
                            variant="danger"
                        >
                            Remove from agency
                        </Button>
                    )}
                    <Row>
                        <Form.Group as={Col} controlId="formGridEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                name="email"
                                onChange={handleChange}
                                defaultValue={user?.email}
                                type="email"
                            />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridUsername">
                            <Form.Label>Username</Form.Label>
                            <Form.Control
                                name="username"
                                onChange={handleChange}
                                defaultValue={user?.username}
                                type="userName"
                            />
                        </Form.Group>
                    </Row>

                    <Row>
                        <Form.Group as={Col} controlId="formGridDisplayName">
                            <Form.Label>Display name</Form.Label>
                            {user.userType != 'influencer' && (
                                <Form.Text className="text-muted">
                                    {' - '}
                                    Display name is automatically generated from first and last name.
                                </Form.Text>
                            )}
                            <Form.Control
                                name="displayName"
                                onChange={handleChange}
                                defaultValue={user?.displayName}
                                disabled={user.userType != 'influencer'}
                            />
                        </Form.Group>
                    </Row>

                    <Row>
                        <Form.Group as={Col} controlId="formFirstName">
                            <Form.Label>First name</Form.Label>
                            <Form.Control name="firstName" onChange={handleChange} defaultValue={user?.firstName} />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formLastName">
                            <Form.Label>Last name</Form.Label>
                            <Form.Control name="lastName" onChange={handleChange} defaultValue={user?.lastName} />
                        </Form.Group>
                    </Row>

                    <Row className="position-relative zindex-1">
                        <Form.Group as={Col} controlId="formGridZip">
                            <Form.Label>Role</Form.Label>
                            <Form.Control
                                name="roles"
                                onChange={handleRole}
                                value={user.roles}
                                as="select"
                                multiple
                                disabled={!hasAccessRight(AdminAclEnum.CHANGE_USER_ROLES)}
                            >
                                {roles.map((role: string) => (
                                    <option key={role}>{role}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        {isUserBrand && (
                            <Form.Group as={Col} controlId="formGridCompany">
                                <div className="autocomplete-input position-relative d-flex flex-column">
                                    <Form.Label>Company</Form.Label>
                                    <AutocompleteInput
                                        items={companyList}
                                        renderItems={['displayName']}
                                        // renderItem={(item) =>
                                        //     <div className='autocomplete-item'>
                                        //         {item.displayName ?? '-'}
                                        //     </div>
                                        // }
                                        value={selectedCompany ?? ''}
                                        setFilter={value => changeFilterHandler(value)}
                                        onSelect={company => changeAutoCompleteHandler(company, 'brandCompany')}
                                    />
                                </div>
                            </Form.Group>
                        )}
                        <Form.Group as={Col} controlId="formGridState">
                            <Form.Label>Type</Form.Label>
                            <Form.Select name="userType" onChange={handleChange} value={user?.userType}>
                                {userType.map((type: string) => (
                                    <option key={getCorrectEnums(type)} value={type}>
                                        {getCorrectEnums(type)}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Row>
                    <Row className="align-items-center my-1" key={user?.id}>
                        {user?.userType === 'influencer' && (
                            <>
                                <Form.Group as={Col} id="formGridCheckbox3">
                                    <Form.Check
                                        onChange={handleCheckbox}
                                        name="hasValueMatch"
                                        label="Value match"
                                        checked={user?.hasValueMatch}
                                    />
                                </Form.Group>
                                {user?.hasValueMatch && (
                                    <Form.Group as={Col} controlId="formGridValueMatchStart">
                                        <Form.Label>Value match start</Form.Label>
                                        <Form.Control
                                            name="valueMatchStart"
                                            onChange={handleChange}
                                            defaultValue={
                                                user?.valueMatchStart
                                                    ? new Date(user.valueMatchStart).toLocaleDateString('en-CA')
                                                    : ''
                                            }
                                            type="date"
                                        />
                                    </Form.Group>
                                )}
                            </>
                        )}
                    </Row>
                    <Row>
                        <Form.Group as={Col} id="formGridCheckbox2">
                            <Form.Check
                                onChange={handleCheckbox}
                                name="isSupervisor"
                                label="Supervisor"
                                checked={user?.isSupervisor}
                            />
                        </Form.Group>
                        {user?.userType === 'influencer' && (
                            <Form.Group as={Col} id="formGridCheckbox3">
                                <Form.Check
                                    onChange={handleCheckbox}
                                    name="hasInfluencerFee"
                                    label="Influencer fee"
                                    checked={user?.hasInfluencerFee}
                                    disabled={!hasAccessRight(AdminAclEnum.INFLUENCER_FEE)}
                                />
                            </Form.Group>
                        )}
                        {user?.userType === 'influencer' && (
                            <Form.Group as={Col} id="formGridCheckbox3">
                                <Form.Check
                                    onChange={handleCheckbox}
                                    name="isIvConnectedClub"
                                    label="IV Connected Club"
                                    checked={user?.isIvConnectedClub}
                                    disabled={!hasAccessRight(AdminAclEnum.INFLUENCER_FEE) || !user?.hasInfluencerFee}
                                />
                            </Form.Group>
                        )}
                        {user?.userType === 'influencer' && (
                            <Form.Group as={Col} id="formGridCheckbox3">
                                <Form.Check
                                    onChange={handleCheckbox}
                                    name="excludeFromMatching"
                                    label="Exclude from matching"
                                    checked={user?.excludeFromMatching}
                                    // disabled={!hasAccessRight(AdminAclEnum.INFLUENCER_FEE) || !user?.hasInfluencerFee}
                                />
                            </Form.Group>
                        )}
                        {isUserBrand && (
                            <Form.Group as={Col} id="isPhoneShown">
                                <Form.Check
                                    onChange={handleCheckbox}
                                    name="isPhoneShown"
                                    label="Show mobile"
                                    checked={user?.isPhoneShown}
                                />
                            </Form.Group>
                        )}
                    </Row>
                    <Button onClick={() => editUser()}>Save</Button>
                </Form>
            </Card>
        </>
    );
}
